import { createAsyncThunk } from '@reduxjs/toolkit';

const getParams = ({ timeFrame, group, filters = {} }) => {
  try {
    const params = {
      filter_by: {
        date: {
          from: timeFrame?.from,
        },
        ...filters,
      },
      date_group: timeFrame?.date_group,
    };
    if (timeFrame?.to) {
      params['filter_by']['date']['to'] = timeFrame?.to;
    }
    if (group?.group_by_1) {
      params['group_by_1'] = group?.group_by_1?.id;
    }
    if (group?.group_by_2) {
      params['group_by_2'] = group?.group_by_2?.id;
    }

    return params;
  } catch {}
};

const getEeoVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const response = atsHttp.post(`/reports/eeo/visual`, params);
  return response;
};

export const fetchEeoVisual = createAsyncThunk(
  'ats-reports/eeo/visual',
  getEeoVisual
);
